import React from 'react';
import { ReactComponent as ImageProductHosting } from '../../media/product-hosting.svg';

const HGImageProductHosting = () => {
  const alt = 'Hospedagem de Sites';

  return (
    <ImageProductHosting aria-label={alt} />
  );
};

export default HGImageProductHosting;
